// db.ts
import { DataInstance, DataPackage, Schema } from '@apis/cas/generated';
import { LpInstance } from '@typings/lp/generated';
import Dexie, { Table } from 'dexie';

export interface FileDb {
  id: string;
  modified: string;
  url: string;
  localCopy: { blob: Blob } | undefined;
  requiresFetch: number; // 0 = false, 1 = true
}

export interface InstanceDbVersion {
  versionUid: string;
}

export class AppDB extends Dexie {
  files!: Table<FileDb>; // Define the table for files
  instances!: Table<LpInstance>;
  rawInstances!: Table<DataInstance>;
  schema!: Table<{ id: string; schema: Schema }>;
  dataPackages!: Table<{ version_id: string; dataPackage: DataPackage }>;

  constructor() {
    super('database');
    this.version(5).stores({
      files: 'id, modified, url, requiresFetch',
      instances: 'uid, dataType',
      rawInstances: 'uid, dataType',
      schema: 'id',
      dataPackages: 'version_id',
    });
  }
}

export const db = new AppDB();
